import { createContext } from 'react'
import { Dataroom } from 'utils/__generated__/graphql'

export type DataroomsContextType = {
  datarooms: Dataroom[]
}

const DataroomsContext = createContext({} as DataroomsContextType)

export default DataroomsContext
